import React from "react";
import { Button } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa"; // Back arrow icon

const BackButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      className="back-btn btn-color d-flex align-items-center justify-content-center border-0"
    >
      <FaArrowLeft />
    </Button>
  );
};

export default BackButton;
